import React from 'react';
// import MaterialTable from 'material-table'
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import UserPermission from './UserPermission';
import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
import SnackbarUtils from '../SnackbarUtils/SnackbarUtlis';
import AddIcon from '@mui/icons-material/Add';

const token = getCookie("bb_metaverse_token");
//const access = JSON.parse(getCookie("bb_cdm_access"));

class UserAccess extends React.Component {
    constructor() {
        super()
        this.state = {
            userAddModal: false,
            userEditModal: false,
            editUser: null,
            first_name: '',
            last_name: '',
            email: '',
            isLoading: false,
            disabled: false,
            columns: [
                { title: 'Id', field: 'id', defaultSort: 'asc', editable: 'never' },
                { title: 'First Name', field: 'first_name' },
                { title: 'Last Name', field: 'last_name' },
                { title: 'Email', field: 'email', editable: 'never' },
                { title: 'Active Status', field: 'is_active', lookup: { false: 'Inactive', true: 'Active' }, },
            ]
        }
        this.state.filter = { first_name: '', last_name: '', email: '', is_active: '' };
        this.state.search = '';
        this.closeUserAddModal = this.closeUserAddModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.fetchOps()
    }

    fetchOps() {
        this.setState({ isLoading: true })
        Service.get('/api/users/get_user/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let data = res.data;
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.open = false
                    
                }
                this.setState({ data: data, isLoading: false })
            })
            .catch(error => {
                // this.props.enqueueSnackbar('Something went wrong!', {
                //     variant: 'error'
                // });
                SnackbarUtils.error('Something went wrong!')
                this.setState({ isLoading: false })
            });
    }

    putOps(data) {
        if (!data.first_name?.trim() || !data.last_name?.trim()) {
            SnackbarUtils.warning('First name and last name are required.');
            return;
        }

        this.setState({ isLoading: true })
        Service.patch('/api/users/update_user_details/', {
            headers: {
                Authorization: "Token " + token,
            },
            data,
        })
            .then(res => {
                this.setState({ userEditModal: false, editUser: null });
                this.fetchOps()
                // this.props.enqueueSnackbar('Successfully Updated', {
                //     variant: 'success'
                // });
                SnackbarUtils.success('Successfully Updated')
            })
            .catch(error => {
                this.setState({ isLoading: false })
                // this.props.enqueueSnackbar('Something went wrong!', {
                //     variant: 'error'
                // });
                SnackbarUtils.error('Something went wrong!')
                this.setState({ isLoading: false })
            });
    }

    closeUserAddModal() {
        this.setState({ userAddModal: false })
    }

    openUserEditModal(user) {
        this.setState({
            userEditModal: true,
            editUser: { ...user },
        });
    }

    closeUserEditModal() {
        this.setState({ userEditModal: false, editUser: null });
    }

    handleEditChange(e) {
        const { name, value } = e.target;
        this.setState(state => ({
            editUser: { ...state.editUser, [name]: name === 'is_active' ? value === 'true' : value },
        }));
    }

    saveEditedUser() {
        const { editUser } = this.state;
        if (!editUser.first_name || !editUser.last_name) {
            SnackbarUtils.warning('First name and last name are required.');
            return;
        }

        const { id, first_name, last_name, email, is_active } = editUser;
        this.putOps({ id, first_name, last_name, email, is_active });
    }

    handleChange(e) {
        let { name, value } = e.target
        this.setState({ [name]: value })
    }

    addUser() {
        if (!this.state.email.includes("@balfourbeatty.com")) {
            alert("You're adding a guest user. Please confirm the email address before adding the user.")
        }
        if (this.state.first_name === '' || this.state.last_name === '' || this.state.email === '') {
            // this.props.enqueueSnackbar('All the fields are required.', {
            //     variant: 'warning',
            // });
            SnackbarUtils.warning('All the fields are required.')
        }
        else {
            var json = {
                email: this.state.email.toLowerCase(),
                email_username: this.state.first_name + "." + this.state.last_name,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                is_active: true,
            }
            this.setState({ isLoading: true, disabled: true })
            Service.post('/api/users/create_user/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: json,
            })
                .then(res => {
                    this.setState({ userAddModal: false, isLoading: false, disabled: false }, () => {
                        this.setPassword(res.data.id)
                    });
                    // this.props.enqueueSnackbar(json.email + ' is created', {
                    //     variant: 'success',
                    // });
                    SnackbarUtils.success(json.email + ' is created')
                    this.fetchOps();
                })
                .catch(error => {
                    console.log(error)
                    if (error.data.email) {
                        // this.props.enqueueSnackbar(error.data.email[0], {
                        //     variant: 'warning',
                        // });
                        SnackbarUtils.warning(error.data.email[0])
                    } else if (error.data.password1) {
                        // this.props.enqueueSnackbar(error.data.password1[0], {
                        //     variant: 'warning',
                        // });
                        SnackbarUtils.warning(error.data.password1[0])
                    } else {
                        this.setState({ isLoading: false, disabled: false });
                        // this.props.enqueueSnackbar('Something went wrong!. Try after sometime.', {
                        //     variant: 'error',
                        // });
                        SnackbarUtils.error('Something went wrong!. Try after sometime.')
                    }
                });
        }
    }

    setPassword(id) {
        Service.get(`/api/users/password_change/?id=${id}`, {
            headers: {
                Authorization: "Token " + token,
            },

        })
            .then(res => {
                // this.fetchOps();
            })
            .catch(error => {
                console.log(error)
                console.log("error")
            });
    }

    render() {
        // Filtering and search logic (like AnimationType.js)
        const { filter, search, data = [] } = this.state;
        const filteredData = (data || []).filter(row =>
            (row.first_name?.toLowerCase().includes(filter.first_name?.toLowerCase() || '')) &&
            (row.last_name?.toLowerCase().includes(filter.last_name?.toLowerCase() || '')) &&
            (row.email?.toLowerCase().includes(filter.email?.toLowerCase() || '')) &&
            (filter.is_active === '' || (String(row.is_active) === filter.is_active)) &&
            (
                (row.first_name?.toLowerCase().includes(search?.toLowerCase() || '')) ||
                (row.last_name?.toLowerCase().includes(search?.toLowerCase() || '')) ||
                (row.email?.toLowerCase().includes(search?.toLowerCase() || ''))
            )
        );
        return (
            <div>
                {this.state.isLoading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'}><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" p={2} gap={2}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                fontSize: 20,
                                color: 'text.primary',
                            }}
                        >
                            Manage Users
                        </Typography>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
                            <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                value={this.state.search}
                                onChange={e => this.setState({ search: e.target.value })}
                                InputProps={{ endAdornment: <SearchIcon /> }}
                            />
                            <IconButton color="primary" onClick={() => this.setState({ userAddModal: true })}>
                                <AddIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                {this.state.columns && this.state.columns.map((column) => (
                                    <TableCell key={column.field}>{column.title}</TableCell>
                                ))}
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row) => (
                                <React.Fragment key={row.id}>
                                    <TableRow>
                                        <TableCell>
                                            <IconButton
                                                aria-label="expand row"
                                                size="small"
                                                onClick={() => {
                                                    let data = this.state.data;
                                                    data.forEach(element => {
                                                        if (element.id === row.id) {
                                                            element.open = !element.open
                                                        } else {
                                                            element.open = false
                                                        }
                                                    });
                                                    this.setState({ data: data })
                                                }}
                                            >
                                                {row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                        </TableCell>
                                        {this.state.columns && this.state.columns.map((column) => (
                                            <TableCell key={column.field}  >
                                                {column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                            </TableCell>
                                        ))}
                                        <TableCell>
                                            <IconButton
                                                aria-label={`Edit ${row.first_name} ${row.last_name}`}
                                                onClick={() => this.openUserEditModal(row)}
                                                size="small"
                                            >
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                                            <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                <Box sx={{ margin: 1 }}>
                                                    <UserPermission value={row} />
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}
                {/* <MaterialTable
                    title={'User Management'}
                    columns={[
                        { title: 'Id', field: 'id', defaultSort: 'asc', editable: 'never' },
                        { title: 'First Name', field: 'first_name' },
                        { title: 'Last Name', field: 'last_name' },
                        { title: 'Email', field: 'email', editable: 'never' },
                        { title: 'Active Status', field: 'is_active', lookup: { false: 'Inactive', true: 'Active' }, },
                    ]}
                    data={this.state.data}
                    isLoading={this.state.isLoading}
                    options={{
                        pageSize: 20,
                        paging: false,
                        pageSizeOptions: [10, 20, 50, 100],
                        headerStyle: {
                            fontWeight: 'bold',
                        },
                        actionsColumnIndex: -1,
                        filtering: true
                    }}
                    detailPanel={
                        rowData => {
                            return (
                                 <UserPermission value={rowData} />
                            )
                        }
                    }
                    editable={{
                        
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve, reject) => {
                                setTimeout(() => {
                                    this.putOps(newData)
                                    resolve();
                                }, 1000)
                            }),
                    }}
                    actions={[
                        {
                            icon: 'add',
                            tooltip: 'Add User',
                            isFreeAction: true,
                            onClick: (event) => {
                                this.setState({ userAddModal: true })
                            }
                        }
                   ]}
                /> */}

                <Dialog
                    open={this.state.userAddModal}
                    onClose={this.closeUserAddModal}
                    aria-labelledby="form-dialog-title"
                    maxWidth="xs"
                >
                    <DialogTitle id="form-dialog-title" >Add User</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="normal"
                            id="first_name"
                            name="first_name"
                            label="First Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={this.handleChange}
                        />
                        <TextField
                            margin="normal"
                            id="last_name"
                            name="last_name"
                            label="Last Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={this.handleChange}
                        />
                        <TextField
                            margin="normal"
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            fullWidth
                            variant="outlined"
                            onChange={this.handleChange}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.closeUserAddModal}
                            color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={this.addUser.bind(this)}
                            color="primary"
                            disabled={this.state.disabled}
                        >
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.userEditModal}
                    onClose={this.closeUserEditModal.bind(this)}
                    aria-labelledby="edit-user-dialog-title"
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle id="edit-user-dialog-title">Edit User</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="normal"
                            name="first_name"
                            label="First Name"
                            fullWidth
                            value={this.state.editUser?.first_name || ''}
                            onChange={this.handleEditChange.bind(this)}
                        />
                        <TextField
                            margin="normal"
                            name="last_name"
                            label="Last Name"
                            fullWidth
                            value={this.state.editUser?.last_name || ''}
                            onChange={this.handleEditChange.bind(this)}
                        />
                        <TextField
                            select
                            margin="normal"
                            name="is_active"
                            label="Active Status"
                            fullWidth
                            value={String(this.state.editUser?.is_active ?? true)}
                            onChange={this.handleEditChange.bind(this)}
                        >
                            <MenuItem value="true">Active</MenuItem>
                            <MenuItem value="false">Inactive</MenuItem>
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeUserEditModal.bind(this)} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.saveEditedUser.bind(this)} color="primary" disabled={this.state.isLoading}>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

// export default withSnackbar(UserAccess);
export default UserAccess;